import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/admin/blog/queue')({})
